import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/EvaluateSelectQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class EvaluateSelectQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "EvaluateSelectQueryStore",
			variables: true,
		})
	}
}

export async function load_EvaluateSelectQuery(params) {
  await initClient()

	const store = new EvaluateSelectQueryStore()

	await store.fetch(params)

	return {
		EvaluateSelectQuery: store,
	}
}
